"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApproval = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var react_1 = require("react");
var launchpadConstants_1 = require("../../launchpadConstants");
var useUser_1 = require("../../shared/hooks/useUser");
var utils_1 = require("../../shared/utils");
function useApproval(_a) {
    var tokenContract = _a.tokenContract, spenderAddress = _a.spenderAddress, amount = _a.amount;
    var account = (0, useUser_1.useUser)().account;
    var _b = (0, react_1.useState)(false), isApproved = _b[0], setIsApproved = _b[1];
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, react_1.useState)(launchpadConstants_1.ZERO_BN), allowance = _d[0], setAllowance = _d[1];
    function approveSpending(value) {
        if (!tokenContract || !account || !spenderAddress)
            return Promise.resolve(undefined);
        setIsLoading(true);
        return tokenContract.methods
            .approve(spenderAddress, value)
            .send({ from: account })
            .then(function () {
            setIsApproved(true);
            return undefined;
        })
            .catch(function (e) {
            return {
                success: false,
                msg: "Approval failed",
                error: e.message,
            };
        })
            .finally(function () { return setIsLoading(false); });
    }
    (0, react_1.useEffect)(function () {
        if (!tokenContract || !account || !spenderAddress)
            return;
        (0, utils_1.call)(tokenContract, "allowance", [account, spenderAddress])
            .then(function (v) { return setAllowance(new bn_js_1.default(v)); })
            .catch(function (e) { return console.error("Failed to determine allowance", e); });
    }, [account, tokenContract, amount.toString(), spenderAddress]);
    (0, react_1.useEffect)(function () {
        var approved = allowance.gtn(0) && allowance.gte(amount);
        setIsApproved(approved);
    }, [allowance, amount.toString()]);
    return {
        isApproved: isApproved,
        isLoading: isLoading,
        approveSpending: approveSpending,
    };
}
exports.useApproval = useApproval;
